export default function AboutAuthor() {
  const stats = [
    { icon: 'ri-calendar-check-line', value: '18+', label: 'лет опыта в переговорах и обучении' },
    { icon: 'ri-building-2-line', value: '100+', label: 'корпоративных проектов' },
    { icon: 'ri-presentation-line', value: '450+', label: 'тренингов проведено' },
    { icon: 'ri-user-star-line', value: '4 500+', label: 'участников обучено' },
    { icon: 'ri-star-line', value: '9,09/10', label: 'средняя оценка качества тренингов' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
            {/* Photo */}
            <div className="lg:col-span-2 flex flex-col items-center">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-gray-200 mb-6 shadow-lg">
                <img
                  src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/d5f5f47c7d94e3dc67c5ef073553230f.jpeg"
                  alt="Алексей Сивко — бизнес-тренер по переговорам"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-1">Алексей Сивко</h3>
              <p className="text-gray-500 text-sm text-center">Бизнес-тренер, эксперт по переговорам</p>
            </div>

            {/* Content */}
            <div className="lg:col-span-3">
              <div className="flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4 w-fit">
                <i className="ri-user-line"></i>
                Об авторе
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Почему мне доверяют <strong>обучение переговорам</strong>
              </h2>
              <div className="space-y-4 text-gray-600 leading-relaxed text-sm md:text-base mb-8">
                <p>
                  Я занимаюсь продажами и переговорами более 18 лет. За это время провёл более 450 корпоративных тренингов для 4500+ участников из Беларуси, России, Казахстана и Израиля. Мои клиенты — собственники бизнеса, коммерческие директора, руководители отделов продаж и закупок.
                </p>
                <p>
                  Мой подход к переговорам основан на философии H2H (Human-to-Human): за каждым столом переговоров — живые люди со своими интересами, страхами и амбициями. Я учу не манипуляциям, а профессиональному управлению решениями через ценность, уважение и долгосрочные отношения.
                </p>
                <p>
                  Я не академический теоретик. Постоянно работаю с реальными бизнесами, выхожу «в поле» вместе с сотрудниками, веду переговоры плечом к плечу с командой. Каждая программа создаётся под конкретную компанию — никаких шаблонов.
                </p>
              </div>

              <div className="grid grid-cols-3 gap-4">
                {stats.map((stat, i) => (
                  <div key={i} className="bg-white rounded-xl p-4 text-center shadow-sm">
                    <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center mx-auto mb-2">
                      <i className={`${stat.icon} text-sm text-teal-600`}></i>
                    </div>
                    <div className="text-lg md:text-xl font-extrabold text-gray-900 mb-0.5">{stat.value}</div>
                    <div className="text-xs text-gray-500 leading-snug">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}